module.exports = __webpack_public_path__ + "static/media/banner-purple-metrics-mobile.a3d74bac.png";